const ObjectTypes = [
    "Object3D",
    "Group",
    "Mesh",
    "Bone",
    "SkinnedMesh",
];

export default ObjectTypes;
export { ObjectTypes };
